const normalizeEmployeeSearch = (value) => (
  value || ''
).trim().toLocaleLowerCase('de-DE');

export const getAdminEmployeeSearchResults = (
  departmentEmployees = [],
  crossDepartmentEmployees = [],
  query = ''
) => {
  const normalizedQuery = normalizeEmployeeSearch(query);

  if (!normalizedQuery) {
    return {
      active: false,
      departmentEmployees,
      crossDepartmentEmployees,
    };
  }

  const matches = (employee) => (
    normalizeEmployeeSearch(employee?.name).includes(normalizedQuery)
  );

  return {
    active: true,
    departmentEmployees: departmentEmployees.filter(matches),
    crossDepartmentEmployees: crossDepartmentEmployees.filter(matches),
  };
};
